import { Download, RefreshCw } from "lucide-react";
import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { ArticleRow, OverviewResponse, QueryParams } from "../api/client";
import { api } from "../api/client";
import { KpiGrid } from "../components/KpiGrid";
import { SearchBox } from "../components/SearchBox";
import { TopArticlesTable } from "../components/TopArticlesTable";

export function DashboardPage({
  query,
  overview,
  articles,
  articleSearch,
  loading,
  onArticleSearch,
  onReload
}: {
  query: QueryParams;
  overview: OverviewResponse | null;
  articles: ArticleRow[];
  articleSearch: string;
  loading: boolean;
  onArticleSearch: (value: string) => void;
  onReload: () => void;
}) {
  if (!overview) return <div className="empty-state">暫無可顯示資料</div>;
  return (
    <div className="page-stack">
      <div className="toolbar-row">
        <h2>總覽</h2>
        <div className="icon-actions">
          <button type="button" title="重新整理" onClick={onReload}>
            <RefreshCw size={16} aria-hidden="true" />
          </button>
          <a className="icon-link" title="CSV 匯出" href={api.exportUrl(query)}>
            <Download size={16} aria-hidden="true" />
          </a>
        </div>
      </div>
      <KpiGrid totals={overview.totals} />
      <section className="analytics-grid">
        <div className="panel wide">
          <div className="panel-heading">
            <h3>每日觀看</h3>
            {loading ? <span>更新中</span> : null}
          </div>
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={overview.daily}>
              <CartesianGrid stroke="#e5e7eb" />
              <XAxis dataKey="view_date" tickMargin={8} />
              <YAxis width={64} />
              <Tooltip />
              <Line type="monotone" dataKey="views" name="觀看" stroke="#067a7a" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="unique_visitors" name="訪客" stroke="#b45309" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="panel">
          <div className="panel-heading">
            <h3>會員 / 一般</h3>
          </div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={overview.daily}>
              <CartesianGrid stroke="#e5e7eb" />
              <XAxis dataKey="view_date" tickMargin={8} />
              <YAxis width={54} />
              <Tooltip />
              <Bar dataKey="member_views" name="會員" stackId="views" fill="#1c2676" />
              <Bar dataKey="public_views" name="一般" stackId="views" fill="#d97706" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </section>
      <section className="panel">
        <div className="panel-heading">
          <h3>Top articles</h3>
          <SearchBox
            value={articleSearch}
            label="搜尋總覽文章"
            placeholder="搜尋標題、作者、文章 ID 或網址"
            onChange={onArticleSearch}
          />
        </div>
        <TopArticlesTable rows={articles} />
      </section>
    </div>
  );
}
